export type TDuplicatedEntityType = 'lead' | 'contact';

export type TDuplicatedErrorMatch = {
    entityType: TDuplicatedEntityType;
    entityId: string;
};

const DUPLICATED_ERROR_PATTERNS: Record<TDuplicatedEntityType, RegExp> = {
    lead: /^Errors\.LeadIsDuplicated:([a-f0-9]+)/i,
    contact: /^Errors\.ContactIsDuplicated:([a-f0-9]+)/i,
};

export const parseDuplicatedError = (
    error: string
): TDuplicatedErrorMatch | null => {
    for (const entityType of Object.keys(
        DUPLICATED_ERROR_PATTERNS
    ) as TDuplicatedEntityType[]) {
        const match = error.match(DUPLICATED_ERROR_PATTERNS[entityType]);
        if (match?.[1]) {
            return { entityType, entityId: match[1] };
        }
    }
    return null;
};
